import {
  BookingCheckInIssue,
  BookingStatus,
  CheckInInstructionsStatus,
  LeadSource,
  PaymentNotes,
  UUID,
} from '@avantstay/arriere-clients/dist/arriereBackoffice'

import {
  BookingAcquisitionView,
  BookingBackToBackView,
  BookingRepeatView,
} from '@new/__global/components/Filters/Filters.types'
import { BookingEarlyCheckInStatus } from '@new/__global/types/booking.types'
import {
  BookingDateFilterCondition,
  BookingDatesRawData,
} from '@new/domains/bookings/screens/bookingsList/BookingsList.types'

import { AuditPaymentStatus } from '@/_new/__global/types/paymentAudit.types'

export interface BookingsColumnFiltersProps {
  acquisition?: BookingAcquisitionView
  checkIn?: BookingDatesRawData
  checkInInstructionsIssues?: BookingCheckInIssue[]
  checkInInstructionsLastSent?: BookingDatesRawData
  checkInInstructionsStatus?: CheckInInstructionsStatus[]
  checkOut?: BookingDatesRawData
  creationDate?: BookingDatesRawData
  cancellationCreationDate?: BookingDatesRawData
  earlyCheckInStatus?: BookingEarlyCheckInStatus[]
  leadSources?: LeadSource[]
  maxPrice?: string
  minPrice?: string
  regionIds?: string[]
  repeated?: BookingRepeatView
  reservationType?: string[]
  riskLevel?: string[]
  securityDepositOnHold?: boolean
  status?: BookingStatus[]
  serviceIds?: UUID[]
  tags?: string[]
  updatedAfter?: string
  bookingRiskStatus?: string[]
  minLeadTime?: string
  maxLeadTime?: string
  balanceMinPrice?: string
  balanceMaxPrice?: string
  paymentAuditFilterInput?: PaymentAuditFilter
  reasons?: string[]
  guestsCount?: { from?: string; to?: string }
  petsCount?: { from?: string; to?: string }
  backToBack?: BookingBackToBackView
  bookingBalance?: { from?: string; to?: string }
  totalCash?: { from?: string; to?: string }
}

export interface BookingsAdvancedFiltersProps {
  longTerm?: boolean
  pendingServiceRequests?: boolean
  dateRange?: BookingDatesRawData
}

export interface BookingsFiltersProps
  extends BookingsColumnFiltersProps,
    BookingsAdvancedFiltersProps {}

export enum QuickFilters {
  all = 'ALL',
  preStayIssues = 'PRE-STAY_ISSUES',
  riskManagement = 'RISK_MANAGEMENT',
  paymentAuditing = 'PAYMENT_AUDITING',
  upcomingArrivals = 'UPCOMING_ARRIVALS',
}

export enum PaymentAuditQuickFilter {
  none = 'NONE',
  newBookings = 'NEW_BOOKINGS',
  followUps = 'FOLLOW_UPS',
  checkInFifteenDays = 'CHECK_IN_FIFTEEN_DAYS',
  ach = 'ACH',
  expediaVcc = 'EXPEDIA_VCC',
  inProgress = 'IN_PROGRESS',
  ownerStays = 'OWNER_STAYS',
  wires = 'WIRES',
  depositRefunds = 'DEPOSIT_REFUNDS',
  unbalancedCheckIns = 'UNBALANCED_CHECK_INS',
}

export interface PaymentAuditFilter {
  paymentPlan?: boolean
  auditStatus?: AuditPaymentStatus[]
  paymentNotes?: PaymentNotes
  followUpDate?: BookingDateFilterCondition
  isRefund?: boolean
  paymentPlanDate?: BookingDateFilterCondition
}
